import { createSlice } from "@reduxjs/toolkit";
import { CollectionsSummary } from "../../types";
import { getCollectionsSummary } from "./action";

interface CollectionsState {
  data: CollectionsSummary[];
  loading: boolean;
  error: string | null;
}

const initialState: CollectionsState = {
  data: [],
  loading: false,
  error: null,
};

const ReportsSlice = createSlice({
  name: "collections",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCollectionsSummary.pending, (state) => {
        state.loading = true;
        state.data = [];
      })
      .addCase(getCollectionsSummary.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.data = action.payload;
        }
      })
      .addCase(getCollectionsSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || null;
        state.data = [];
      });
  },
});

// export const {} = ReportsSlice.actions;

export default ReportsSlice.reducer;
